import React from 'react';
import classNames from 'classnames';

import Button, { BUTTON_COLORS, BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';

interface PrompterButtonProps {
    isPrompterShowing: boolean;
    onClick: () => void;
    className?: string;
}

const PrompterButton: React.FC<PrompterButtonProps> = ({
    isPrompterShowing,
    onClick,
    className,
}) => {
    return (
        <Button
            text="Prompter"
            color={BUTTON_COLORS.TERTIARY}
            variant={BUTTON_VARIANTS.OUTLINE}
            iconLeft="feed"
            onClick={onClick}
            className={classNames(className, {
                active: isPrompterShowing,
            })}
        />
    );
};

export default React.memo(PrompterButton);
